export const WVPP = 'West Virginia Perinatal Partnership';
export const HER = 'Healthy Expectations Resource';
export const ExpiredLink = 'Direct resource links expire after 120 days. Start again to generate new resources.';
export const EmailPopupText = 'We will email a direct link to these resources so you can revisit them later. Your email will not be used for any other purpose.';
export const EmailSuccess = 'Sent! Check your inbox.';
export const TooltipText = 'We will email a direct link to these resources so you can revisit them later. Your email will not be used for any other purpose.';
